/**
 * Utilitaires pour la gestion des dates en français
 */

/**
 * Convertit une date ISO en format français (jj/mm/aaaa)
 * @param {string} isoDate - Date au format ISO (yyyy-mm-dd)
 * @returns {string} Date au format français (jj/mm/aaaa)
 */
export const isoToFrenchDate = (isoDate) => {
    if (!isoDate) return '';
    
    const date = new Date(isoDate);
    if (isNaN(date.getTime())) return isoDate;
    
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    
    return `${day}/${month}/${year}`;
};

/**
 * Convertit une date française (jj/mm/aaaa) en format ISO (yyyy-mm-dd)
 * @param {string} frenchDate - Date au format français (jj/mm/aaaa)
 * @returns {string} Date au format ISO (yyyy-mm-dd)
 */
export const frenchDateToIso = (frenchDate) => {
    if (!frenchDate) return '';
    
    // Si c'est déjà au format ISO, le retourner tel quel
    if (frenchDate.match(/^\d{4}-\d{2}-\d{2}/)) return frenchDate;
    
    const parts = frenchDate.split('/');
    if (parts.length !== 3) return frenchDate;
    
    const [day, month, year] = parts;
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};

/**
 * Formate une date en français avec le nom du mois
 * @param {string|Date} date - Date à formater
 * @param {boolean} includeTime - Inclure l'heure ou non
 * @returns {string} Date formatée (ex: "21 octobre 2025" ou "21 octobre 2025 à 14:30")
 */
export const formatFrenchDate = (date, includeTime = false) => {
    if (!date) return '';
    
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    if (isNaN(dateObj.getTime())) return date;
    
    const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        ...(includeTime && {
            hour: '2-digit',
            minute: '2-digit'
        })
    };
    
    return new Intl.DateTimeFormat('fr-FR', options).format(dateObj);
};

/**
 * Formate une date en français format court
 * @param {string|Date} date - Date à formater
 * @returns {string} Date formatée (ex: "21/10/2025")
 */
export const formatShortFrenchDate = (date) => {
    if (!date) return '';
    
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    if (isNaN(dateObj.getTime())) return date;
    
    return new Intl.DateTimeFormat('fr-FR').format(dateObj);
};

